/* raw layout hash: _batch-qr-code-generator-asset-placards-layout:07c0d927239f6c999951785b03bb119dc4adb093cc677740e31a31f3ed4eddc3 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_batch-qr-code-generator-asset-placards-layout" — renders its page content through the router outlet.
export default function BatchQrCodeGeneratorAssetPlacardsLayout() {
  return <AppShell layoutName="_batch-qr-code-generator-asset-placards-layout" menu={LAYOUT_MENUS['_batch-qr-code-generator-asset-placards-layout']} />;
}
